import { api } from './apiThunks'

/*
 * Fetch action utility
 *
 * @param {String} entity
 * @param {String} uri
 * @param {Object} actionTypes
 * @param {Object} params
 * @param {Object} filters
 * @param {Bool} force
 * @return {*}
 */
export function fetch(entity, uri, actionTypes, params = {}, filters = {}, force) {
	return (dispatch, getState) => {
		const state = getState()

		if (Object.keys(filters).length > 0) {
			let filtersArr = []
			for (let key in filters) {
				filtersArr.push(`${key}=${filters[key]}`)
			}
			const joinedFilters = filtersArr.join('&')
			uri = `${uri}?${joinedFilters}`
		}

		const { [entity]: { isFetching } } = state
		if (isFetching !== null && !force) return false
		return api.get(uri, params)
			.then(response => response.json())
			.then(json => dispatch({
				type: actionTypes.receive,
				payload: json
			}))
	}
}
